export enum CollectionMethodEnum {
    PerUnit = 'Por unidade',
    SingleValue = 'Valor único',
    NoCharge = 'Sem cobrança',
}